import { Avatar, Card, Col, Row, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { PiMapPinFill } from "react-icons/pi";
import "./style.css";
import { useNavigate } from "react-router-dom";
import CarRegistrationNumberPlate from "../../../../../components/Elements/CarRegistrationNumberPlate";
import {
  getBookingStatus,
  getEllipsedString,
  getInitials,
  getServicesList,
} from "../../../../../config/utils";
import { bookingStatusDetails } from "../../../../../config/utils/constants";
import { adminActionIdentifier } from "../../../../../config/utils/StatusIdentifier";

const BookingCard = ({ bookingData }) => {
  const navigate = useNavigate();
  // PENDING => 0
  // COMPLETED => 1
  // REJECTED => 2
  // ACCEPTED => 3,
  // INPROGRESS => 4

  const servicesList = (
    <ul className="flex flex-col p-0 m-0">
      {bookingData?.services.length &&
        bookingData?.services.map((service, index) => (
          <li key={index}>
            {index + 1}. {service?.name}
          </li>
        ))}
    </ul>
  );

  console.log(bookingData, "bookingData");

  const [servicesLength, setServicesLength] = useState(0);

  useEffect(() => {
    if (bookingData) {
      setServicesLength(bookingData?.services?.length);
    }
  }, [bookingData]);

  return (
    <React.Fragment>
      {bookingData && (
        <Card
          bordered={false}
          className="p-0 mb-4 rounded-[17px] border-[#f5f5f5] border-[10px] custom-shadow-none"
          onClick={() => navigate(`/booking/${bookingData?.id}`)}
        >
          <Row>
            {bookingData?.dispute && (
              <Col
                span={24}
                className="mt-[-10px] mb-2 flex items-center justify-end"
              >
                <Tag
                  color={
                    bookingData?.dispute?.adminAction ? "success" : "error"
                  }
                  className="m-0"
                >
                  {bookingData?.dispute?.adminAction ? "resolved" : "disputed"}
                </Tag>
              </Col>
            )}
            <Col span={6} className="sm:mb-2 ">
              <Avatar
                className="mr-2"
                src={bookingData?.serviceProvider?.imageThumbUrl}
                size={60}
              >
                {getInitials(
                  bookingData?.serviceProvider?.userDetail?.businessName,
                )}
              </Avatar>
            </Col>
            <Col span={18}>
              <Row>
                <Col md={24} sm={24} xs={24}>
                  <div className="mb-4">
                    <div className="flex ">
                      <div className="ml-1 sm:mr-2">
                        <h5 className="heading-5 font-bold mb-0">
                          {getEllipsedString(
                            bookingData?.serviceProvider?.userDetail
                              ?.businessName,
                            10,
                          )}
                        </h5>
                      </div>

                      {bookingData?.serviceProvider?.badges &&
                      bookingData?.serviceProvider?.badges.length ? (
                        <div className="flex items-center sm:w-[50px]">
                          {bookingData?.serviceProvider?.badges.map((badge) => (
                            <img
                              key={badge?.id}
                              src={badge?.imageUrl}
                              alt={badge?.name}
                              className="img-fluid badge w-[30px] inline-block mb-2 mr-2"
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="flex">
                      <div className="w-[24px]">
                        <PiMapPinFill className="text-primary text-xl" />
                      </div>
                      <small className="ml-1 text-gray-500 font-semibold ellipsis">
                        {
                          bookingData?.serviceProvider?.userDetail
                            ?.businessLocation
                        }
                      </small>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={24} sm={24} xs={24}>
              {/* previous work */}
              {/* <div>
                                <hr className='border-dashed border-1 border-gray-200 mb-2' />
                                <div className='flex sm:flex-row flex-col'>
                                    {bookingData?.services && bookingData?.services.length ? (
                                        <React.Fragment>
                                            {bookingData?.services.slice(0, 2).map((service, index) => (
                                                <small key={index} className='text-gray-500 text-xs mb-2 font-semibold' >
                                                    {service?.name}

                                                    {index < bookingData?.services.slice(0, 2).length - 1 &&
                                                        (<span className='mr-1'>,</span>)}
                                                    {index === 2 && bookingData?.services.length > 2 ?
                                                        (<span className='mr-1'>...</span>) : ''}
                                                </small>
                                            ))}
                                            {bookingData?.services?.length > 3 ? (
                                                <Tooltip title={servicesList}>
                                                    <p className='text-xs sm:ml-2 cursor-pointer'>show all</p>
                                                </Tooltip>
                                            ) : ''}
                                        </React.Fragment>
                                    ) : ''}
                                </div>
                                <hr className='border-dashed border-1 border-gray-200 mb-2' />
                            </div> */}
              {/* updated work */}
              <div>
                <hr className="border-dashed border-1 border-gray-200 mb-2" />
                {/* <div className='flex justify-start my-2 flex-wrap gap-2'>
                                    {
                                        bookingData?.selectedCategories &&
                                            bookingData?.selectedCategories?.length > 0 ? (
                                            <React.Fragment>
                                                {
                                                    bookingData?.selectedCategories[0].subServices?.length > 0 ?
                                                        <span className='flex gap-1 items-center justify-start'>
                                                            <p className='text-gray-500 font-semibold text-xs  w-fit text-nowrap'>
                                                                {bookingData?.selectedCategories[0].name?.length > 8 ? bookingData?.selectedCategories[0].name?.slice(0, 9) + '... ,' : bookingData?.selectedCategories[0].name + ','}
                                                            </p>
                                                            <p className='text-gray-500 font-semibold text-xs w-fit text-nowrap'>
                                                                {bookingData?.selectedCategories[0].subServices[0]?.name + ' ...'}
                                                            </p>
                                                        </span>
                                                        :
                                                        <p className='text-center w-full sm:w-fit'>-</p>

                                                }
                                                {bookingData?.selectedCategories?.length > 0 &&
                                                    bookingData?.selectedCategories[0]?.subServices?.length > 0 &&
                                                    bookingData?.selectedCategories[0]?.subServices[0]?.subServices?.length > 0
                                                    ? (
                                                        <Tooltip title={getServicesList(bookingData?.selectedCategories[0]?.subServices[0]?.subServices, true)}>
                                                            <p className='text-xs cursor-pointer'>show all</p>
                                                        </Tooltip>
                                                    ) : ''}
                                            </React.Fragment>
                                        ) : (
                                            <small className='text-xs'>Services not available</small>
                                        )
                                    }
                                </div> */}
                <div className="flex justify-start my-2 flex-wrap gap-2">
                  {bookingData?.services && servicesLength > 0 ? (
                    <React.Fragment>
                      {
                        bookingData?.services?.slice(0, 5)?.map((service) => {
                          return (
                            <span className="flex gap-1 items-center justify-start">
                              <p className="text-gray-500 font-semibold text-xs  w-fit text-nowrap">
                                {service.name?.length > 14
                                  ? service.name?.slice(0, 15) + "... ,"
                                  : service.name + ","}
                                {/* <span className='font-semibold'>£ {service?.percentage} </span> */}
                              </p>
                              {/* <p className='text-gray-500 font-semibold text-xs w-fit text-nowrap'>
                                                                                                {jobData?.selectedCategories[0].subServices[0]?.name + ' ...'}
                                                                                            </p> */}
                            </span>
                          );
                        })
                        //         :
                        // <p className='text-center w-full sm:w-fit'>-</p>
                      }
                      {servicesLength > 5 && <span>...</span>}
                      {servicesLength > 5 && (
                        <Tooltip
                          title={getServicesList(bookingData?.services, false)}
                        >
                          <p className="text-xs cursor-pointer">show all</p>
                        </Tooltip>
                      )}
                    </React.Fragment>
                  ) : (
                    <small className="text-xs">Services not available</small>
                  )}
                </div>
                <hr className="border-dashed border-1 border-gray-200 mb-2" />
              </div>

              <div className="flex justify-between items-center">
                <div
                  className={`flex justify-center items-center border rounded-md px-2 py-1 md:w-2/6 lg:w-2/6 xl:w-2/6 w-2/6 h-[40px]
                                    border-${getBookingStatus(bookingData?.status)}
                                `}
                >
                  <span
                    className={`text-xs text-${getBookingStatus(bookingData?.status)}`}
                  >
                    {bookingStatusDetails[bookingData?.status]?.label}
                  </span>
                </div>
                <div className="md:w-3/6 lg:w-2/6 xl:w-2/6 w-2/6 ">
                  <CarRegistrationNumberPlate
                    regNumber={bookingData?.vehicleRegistrationNo}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </React.Fragment>
  );
};

export default BookingCard;
